import { Link, useLoaderData, useParams } from "react-router-dom";
import * as API from "../services/nutricion";

import { OpcionesEstadosTratamientos } from '../components/OpcionesEstadosTratamientos';

export async function loader({ params }) {
  const token = sessionStorage.getItem("token");

  // Si no hay token, simplemente NO llamamos a la API y retornamos null
  if (!token) {
    return null;
  }
  return API.getNutricionByID(params.nutricionId);
}

export function NutricionItem(props) {
  const nutricion = useLoaderData();
  const errorMessage = nutricion.message;

  const nutrResp = nutricion.meta?.nutrResp;
  const nutrFecha = nutricion.meta?.metaFecha;
  const nutrNumses = nutricion.meta?.nutrNumses;
  const nutrMedio = nutricion.meta?.nutrMedio;
  const nutrPeso = nutricion.meta?.nutrPeso;
  const nutrTalla = nutricion.meta?.nutrTalla;

  const nutrDondcomid = nutricion.meta?.nutrDondcomid;
  const nutrQuiencomid = nutricion.meta?.nutrQuiencomid;
  const nutrEnccocRad = nutricion.meta?.nutrEnccocRad;
  const nutrEnccampRad = nutricion.meta?.nutrEnccampRad;

  const nutrPichoras = nutricion.meta?.nutrPichoras;
  const nutrComrap = nutricion.meta?.nutrComrap;
  const nutrApet = nutricion.meta?.nutrApet;
  const nutrTrastdig = nutricion.meta?.nutrTrastdig;
  const nutrTrastdigEsp = nutricion.meta?.nutrTrastdigEsp;
  const nutrAlimmalestRad = nutricion.meta?.nutrAlimmalestRad;
  const nutrAlimmalestEsp = nutricion.meta?.nutrAlimmalestEsp;
  const nutrAlergalimRad = nutricion.meta?.nutrAlergalimRad;
  const nutrAlergalimEsp = nutricion.meta?.nutrAlergalimEsp;
  const nutrPesotiempRad = nutricion.meta?.nutrPesotiempRad;
  const nutrPesotiempEsp = nutricion.meta?.nutrPesotiempEsp;
  const nutrSuplalimRad = nutricion.meta?.nutrSuplalimRad;
  const nutrSuplalimEsp = nutricion.meta?.nutrSuplalimEsp;

  const nutrDigest = nutricion.meta?.nutrDigest;
  const nutrRetliqu = nutricion.meta?.nutrRetliqu;
  const nutrHorarcom = nutricion.meta?.nutrHorarcom;
  const nutrEvaldesay = nutricion.meta?.nutrEvaldesay;
  const nutrEvalman = nutricion.meta?.nutrEvalman;
  const nutrEvalcomid = nutricion.meta?.nutrEvalcomid;
  const nutrEvalmeri = nutricion.meta?.nutrEvalmeri;
  const nutrEvalcena = nutricion.meta?.nutrEvalcena;
  const nutrEvallact = nutricion.meta?.nutrEvallact;
  const nutrEvalverd = nutricion.meta?.nutrEvalverd;
  const nutrEvalfrit = nutricion.meta?.nutrEvalfrit;
  const nutrEvalcarn = nutricion.meta?.nutrEvalcarn;
  const nutrEvalfrut = nutricion.meta?.nutrEvalfrut;
  const nutrEvalsals = nutricion.meta?.nutrEvalsals;
  const nutrEvalpesc = nutricion.meta?.nutrEvalpesc;
  const nutrEvallegu = nutricion.meta?.nutrEvallegu;
  const nutrEvalcafte = nutricion.meta?.nutrEvalcafte;
  const nutrEvalhuev = nutricion.meta?.nutrEvalhuev;
  const nutrEvalcere = nutricion.meta?.nutrEvalcere;
  const nutrEvaldulc = nutricion.meta?.nutrEvaldulc;
  const nutrEvalemb = nutricion.meta?.nutrEvalemb;
  const nutrEvalagua = nutricion.meta?.nutrEvalagua;
  const nutrEvalfsec = nutricion.meta?.nutrEvalfsec;
  const nutrEvalrefr = nutricion.meta?.nutrEvalrefr;
  const nutrObs = nutricion.meta?.nutrObs;
  const nutrEstado = nutricion.meta?.nutrEstado || 'seguimiento';

  const nutrDate = new Date(nutricion.date);
  const diffDate = Math.abs(new Date() - nutrDate) / 36e5;

  let { tratamientoId } = useParams();

  return (
    <>
      <div id='content'>
        {nutricion.length === 0 ? (
          <div>Cargando...</div>
        ) : errorMessage ? (
          <p>{errorMessage}</p>
        ) : (
          <form id='formUpdatelement'>
            <fieldset id='disabledContainer' disabled='disabled'>
              <div className='grid--2col'>
                <div className='field'>
                  <label htmlFor='nutrResp'>Responsable</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='nutrResp'
                      required
                      type='text'
                      readOnly
                      value={nutrResp}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='nutrFecha'>Fecha visita</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='nutrFecha'
                      required
                      type='date'
                      readOnly
                      value={nutrFecha}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='nutrNumses'>Número de sesión</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='nutrNumses'
                      required
                      disabled
                      type='number'
                      readOnly
                      value={nutrNumses}
                    />
                  </div>
                </div>

                <div className='field'>
                  <label htmlFor='nutrMedio'>Medio</label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='nutrMedio'
                        required
                        name='nutrMedio'
                        readOnly
                        value={nutrMedio}
                      >
                        <option disabled value=''>
                          -- Selecciona una opción --
                        </option>
                        <option value='presencial'>Presencial</option>
                        <option value='videoconferencia'>
                          Videoconferencia
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                {(props.userRole.includes('administrador')) && (
                <div className='field'>
                  <label htmlFor='nutrEstado'>Estado de seguimiento</label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='nutrEstado'
                        readOnly
                        name='nutrEstado'
                        value={nutrEstado}
                      >
                        { OpcionesEstadosTratamientos.map((option) => (
                          <option
                            key={option.value}
                            value={option.value}
                            disabled={option.disabled}
                          >
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
                )}

              </div>

              {nutrNumses === 1 ? (
                <>
                  <div className='grid--2col'>
                    <div className='field'>
                      <label htmlFor='nutrPeso'>Peso</label>
                      <div className='control'>
                        <input
                          className='input'
                          id='nutrPeso'
                          required
                          type='text'
                          readOnly
                          value={nutrPeso}
                        />
                      </div>
                    </div>
                    <div className='field'>
                      <label htmlFor='nutrTalla'>Talla</label>
                      <div className='control'>
                        <input
                          className='input'
                          id='nutrTalla'
                          required
                          type='text'
                          readOnly
                          value={nutrTalla}
                        />
                      </div>
                    </div>
                  </div>

                  <div className='grid--2col'>
                    <div className='field'>
                      <label htmlFor='nutrDondcomid'>
                        ¿Dónde suele realizar las principales comidas?
                      </label>
                      <div className='control'>
                        <div className='select'>
                          <select
                            className='select'
                            id='nutrDondcomid'
                            name='nutrDondcomid'
                            readOnly
                            value={nutrDondcomid}
                          >
                            <option disabled value='default'>
                              -- Selecciona una opción --
                            </option>
                            <option value='bar-rest'>Bar/Restaurante</option>
                            <option value='dom-prop'>Domicilio propio</option>
                            <option value='casa-famil'>
                              Casa de familiares
                            </option>
                            <option value='otros'>Otros</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className='field'>
                      <label htmlFor='nutrQuiencomid'>
                        ¿Con quién realiza las comidas?
                      </label>
                      <div className='control'>
                        <div className='select'>
                          <select
                            className='select'
                            id='nutrQuiencomid'
                            name='nutrQuiencomid'
                            readOnly
                            value={nutrQuiencomid}
                          >
                            <option disabled value='default'>
                              -- Selecciona una opción --
                            </option>
                            <option value='solo'>Solo</option>
                            <option value='con-famil'>Con familiares</option>
                            <option value='con-comp-trab'>
                              Con compañeros de trabajo
                            </option>
                            <option value='con-amig'>Con amigos</option>
                            <option value='otros'>Otros</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div
                      className='field key'
                      data-key={nutrEnccocRad?.toString()}
                    >
                      <div className='control'>
                        <label className='radio-title'>
                          ¿Se encarga de cocinar?
                        </label>
                        <label className='radio' htmlFor='nutrEnccocRadSi'>
                          <input
                            id='nutrEnccocRadSi'
                            name='nutrEnccocRad'
                            type='radio'
                            value='Si'
                            readOnly
                            checked={nutrEnccocRad === "Si"}
                          />
                          Si
                        </label>
                        <label className='radio' htmlFor='nutrEnccocRadNo'>
                          <input
                            id='nutrEnccocRadNo'
                            name='nutrEnccocRad'
                            type='radio'
                            value='No'
                            readOnly
                            checked={nutrEnccocRad === "No"}
                          />
                          No
                        </label>
                      </div>
                    </div>
                    <div
                      className='field key'
                      data-key={nutrEnccampRad?.toString()}
                    >
                      <div className='control'>
                        <label className='radio-title'>
                          ¿Se encarga de hacer la compra?
                        </label>
                        <label className='radio' htmlFor='nutrEnccampRadSi'>
                          <input
                            id='nutrEnccampRadSi'
                            name='nutrEnccampRad'
                            type='radio'
                            value='Si'
                            readOnly
                            checked={nutrEnccampRad === "Si"}
                          />
                          Si
                        </label>
                        <label className='radio' htmlFor='nutrEnccampRadNo'>
                          <input
                            id='nutrEnccampRadNo'
                            name='nutrEnccampRad'
                            type='radio'
                            value='No'
                            readOnly
                            checked={nutrEnccampRad === "No"}
                          />
                          No
                        </label>
                      </div>
                    </div>

                    <div
                      className='field key'
                      data-key={nutrPichoras?.toString()}
                    >
                      <div className='control'>
                        <label className='radio-title'>
                          ¿Suele picar entre horas?
                        </label>
                        <label className='radio' htmlFor='nutrPichoras01'>
                          <input
                            id='nutrPichoras01'
                            name='nutrPichoras'
                            type='radio'
                            value='Si'
                            readOnly
                            checked={nutrPichoras === "Si"}
                          />
                          Si
                        </label>
                        <label className='radio' htmlFor='nutrPichoras02'>
                          <input
                            id='nutrPichoras02'
                            name='nutrPichoras'
                            type='radio'
                            value='No'
                            readOnly
                            checked={nutrPichoras === "No"}
                          />
                          No
                        </label>
                        <label className='radio' htmlFor='nutrPichoras03'>
                          <input
                            id='nutrPichoras03'
                            name='nutrPichoras'
                            type='radio'
                            value='A veces'
                            readOnly
                            checked={nutrPichoras === "A veces"}
                          />
                          A veces
                        </label>
                      </div>
                    </div>

                    <div
                      className='field key'
                      data-key={nutrComrap?.toString()}
                    >
                      <div className='control'>
                        <label className='radio-title'>
                          ¿Come demasiado rápido?
                        </label>
                        <label className='radio' htmlFor='nutrComrap01'>
                          <input
                            id='nutrComrap01'
                            name='nutrComrap'
                            type='radio'
                            value='Si'
                            readOnly
                            checked={nutrComrap === "Si"}
                          />
                          Si
                        </label>
                        <label className='radio' htmlFor='nutrComrap02'>
                          <input
                            id='nutrComrap02'
                            name='nutrComrap'
                            type='radio'
                            value='No'
                            readOnly
                            checked={nutrComrap === "No"}
                          />
                          No
                        </label>
                        <label className='radio' htmlFor='nutrComrap03'>
                          <input
                            id='nutrComrap03'
                            name='nutrComrap'
                            type='radio'
                            value='A veces'
                            readOnly
                            checked={nutrComrap === "A veces"}
                          />
                          A veces
                        </label>
                      </div>
                    </div>

                    <div className='field key' data-key={nutrApet?.toString()}>
                      <div className='control'>
                        <label className='radio-title'>
                          ¿Cómo es su apetito?
                        </label>
                        <label className='radio' htmlFor='nutrApet01'>
                          <input
                            id='nutrApet01'
                            name='nutrApet'
                            type='radio'
                            value='Bueno'
                            readOnly
                            checked={nutrApet === "Bueno"}
                          />
                          Bueno
                        </label>
                        <label className='radio' htmlFor='nutrApet02'>
                          <input
                            id='nutrApet02'
                            name='nutrApet'
                            type='radio'
                            value='Malo'
                            readOnly
                            checked={nutrApet === "Malo"}
                          />
                          Malo
                        </label>
                        <label className='radio' htmlFor='nutrApet03'>
                          <input
                            id='nutrApet03'
                            name='nutrApet'
                            type='radio'
                            value='Regular'
                            readOnly
                            checked={nutrApet === "Regular"}
                          />
                          Regular
                        </label>
                      </div>
                    </div>

                    <div
                      className='field key'
                      data-key={nutrTrastdig.toString()}
                    >
                      <label htmlFor='nutrTrastdig'>
                        ¿Suele padecer de algún trastorno digestivo?
                      </label>
                      <div className='control'>
                        <div className='select'>
                          <select
                            className='select'
                            id='nutrTrastdig'
                            readOnly
                            name='nutrTrastdig'
                            value={nutrTrastdig}
                          >
                            <option disabled value='default'>
                              -- Selecciona una opción --
                            </option>
                            <option value='si-pasad'>Sí, en el pasado</option>
                            <option value='si-actua'>Sí actualmente</option>
                            <option value='si-pasad-actua'>
                              Sí, en el pasado y actualmente
                            </option>
                            <option value='no'>No</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className='field lock'>
                      <label htmlFor='nutrTrastdigEsp'>Especificar</label>
                      <div className='control'>
                        <div className='select'>
                          <select
                            className='select'
                            id='nutrTrastdigEsp'
                            readOnly
                            name='nutrTrastdigEsp'
                            value={nutrTrastdigEsp}
                          >
                            <option disabled value=''>
                              -- Selecciona una opción --
                            </option>
                            <option value='estren'>Estreñimiento</option>
                            <option value='diarr'>Diarrea</option>
                            <option value='gastr'>Gastritis</option>
                            <option value='indig'>Indigestión</option>
                            <option value='ulce'>Úlcera</option>
                            <option value='digestp'>Digestiones pesadas</option>
                            <option value='otros'>Otros</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    {/* AQUI FALTAN 4 RADIO BUTTONS ¿toma alimentos...*/}
                    <div
                      className='field key'
                      data-key={nutrAlimmalestRad?.toString()}
                    >
                      <div className='control'>
                        <label className='radio-title'>
                          ¿Toma alimentos que le causen malestar?
                        </label>
                        <label className='radio' htmlFor='nutrAlimmalestRadSi'>
                          <input
                            id='nutrAlimmalestRadSi'
                            name='nutrAlimmalestRad'
                            type='radio'
                            value='Si'
                            readOnly
                            checked={nutrAlimmalestRad === "Si"}
                          />
                          Si
                        </label>
                        <label className='radio' htmlFor='nutrAlimmalestRadNo'>
                          <input
                            id='nutrAlimmalestRadNo'
                            name='nutrAlimmalestRad'
                            type='radio'
                            value='No'
                            readOnly
                            checked={nutrAlimmalestRad === "No"}
                          />
                          No
                        </label>
                      </div>
                    </div>
                    <div className='field lock'>
                      <label htmlFor='nutrAlimmalestEsp'>
                        Malestar - Especificar
                      </label>
                      <div className='control'>
                        <input
                          className='input'
                          id='nutrAlimmalestEsp'
                          type='text'
                          readOnly
                          value={nutrAlimmalestEsp}
                        />
                      </div>
                    </div>
                    <div
                      className='field key'
                      data-key={nutrAlergalimRad?.toString()}
                    >
                      <div className='control'>
                        <label className='radio-title'>
                          ¿Padece de alguna alergia alimentaria?
                        </label>
                        <label className='radio' htmlFor='nutrAlergalimRadSi'>
                          <input
                            id='nutrAlergalimRadSi'
                            name='nutrAlergalimRad'
                            type='radio'
                            value='Si'
                            readOnly
                            checked={nutrAlergalimRad === "Si"}
                          />
                          Si
                        </label>
                        <label className='radio' htmlFor='nutrAlergalimRadNo'>
                          <input
                            id='nutrAlergalimRadNo'
                            name='nutrAlergalimRad'
                            type='radio'
                            value='No'
                            readOnly
                            checked={nutrAlergalimRad === "No"}
                          />
                          No
                        </label>
                      </div>
                    </div>
                    <div className='field lock'>
                      <label htmlFor='nutrAlergalimEsp'>
                        Alergia - Especificar
                      </label>
                      <div className='control'>
                        <input
                          className='input'
                          id='nutrAlergalimEsp'
                          type='text'
                          readOnly
                          value={nutrAlergalimEsp}
                        />
                      </div>
                    </div>
                    <div
                      className='field key'
                      data-key={nutrPesotiempRad?.toString()}
                    >
                      <div className='control'>
                        <label className='radio-title'>
                          ¿Mantiene su peso estable a lo largo del tiempo?
                        </label>
                        <label className='radio' htmlFor='nutrPesotiempRadSi'>
                          <input
                            id='nutrPesotiempRadSi'
                            name='nutrPesotiempRad'
                            type='radio'
                            value='Si'
                            readOnly
                            checked={nutrPesotiempRad === "Si"}
                          />
                          Si
                        </label>
                        <label className='radio' htmlFor='nutrPesotiempRadNo'>
                          <input
                            id='nutrPesotiempRadNo'
                            name='nutrPesotiempRad'
                            type='radio'
                            value='No'
                            readOnly
                            checked={nutrPesotiempRad === "No"}
                          />
                          No
                        </label>
                      </div>
                    </div>
                    <div className='field lock'>
                      <label htmlFor='nutrPesotiempEsp'>
                        Peso - Especificar
                      </label>
                      <div className='control'>
                        <input
                          className='input'
                          id='nutrPesotiempEsp'
                          type='text'
                          readOnly
                          value={nutrPesotiempEsp}
                        />
                      </div>
                    </div>
                    <div
                      className='field key'
                      data-key={nutrSuplalimRad?.toString()}
                    >
                      <div className='control'>
                        <label className='radio-title'>
                          ¿Toma algún suplemento vitamínico o mineral?
                        </label>
                        <label className='radio' htmlFor='nutrSuplalimRadSi'>
                          <input
                            id='nutrSuplalimRadSi'
                            name='nutrSuplalimRad'
                            type='radio'
                            value='Si'
                            readOnly
                            checked={nutrSuplalimRad === "Si"}
                          />
                          Si
                        </label>
                        <label className='radio' htmlFor='nutrSuplalimRadNo'>
                          <input
                            id='nutrSuplalimRadNo'
                            name='nutrSuplalimRad'
                            type='radio'
                            value='No'
                            readOnly
                            checked={nutrSuplalimRad === "No"}
                          />
                          No
                        </label>
                      </div>
                    </div>
                    <div className='field lock'>
                      <label htmlFor='nutrSuplalimEsp'>
                        Suplemento - Especificar
                      </label>
                      <div className='control'>
                        <input
                          className='input'
                          id='nutrSuplalimEsp'
                          type='text'
                          readOnly
                          value={nutrSuplalimEsp}
                        />
                      </div>
                    </div>

                    <div className='field'>
                      <label htmlFor='nutrDigest'>Digestión- Nutrición</label>
                      <div className='control'>
                        <div className='select'>
                          <select
                            className='select'
                            id='nutrDigest'
                            name='nutrDigest'
                            readOnly
                            value={nutrDigest}
                          >
                            <option disabled value='default'>
                              -- Selecciona una opción --
                            </option>
                            <option value='no-pat-bien'>
                              No hay patología digestiva y se nutre bien
                            </option>
                            <option value='no-pat-med'>
                              No hay patología digestiva y se nutre medianamente
                              bien
                            </option>
                            <option value='no-pat-mal'>
                              No hay patología digestiva y se nutre mal
                            </option>
                            <option value='pat-bien'>
                              Hay patología digestiva y se nutre bien
                            </option>
                            <option value='pat-med'>
                              Hay patología digestiva y se nutre medianamente
                              bien
                            </option>
                            <option value='pat-mal'>
                              Hay patología digestiva y se nutre mal
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className='field'>
                      <label htmlFor='nutrRetliqu'>Retención de líquidos</label>
                      <div className='control'>
                        <div className='select'>
                          <select
                            className='select'
                            id='nutrRetliqu'
                            name='nutrRetliqu'
                            readOnly
                            value={nutrRetliqu}
                          >
                            <option disabled value='default'>
                              -- Selecciona una opción --
                            </option>
                            <option value='no-hinch-extr'>
                              No sensación de hinchazón en extremidades
                            </option>
                            <option value='hinch-extr'>
                              Sensación de hinchazón en extremidades
                            </option>
                            <option value='hinch-extr-sint-exte'>
                              Sensación de hinchazón en extremidades + presencia
                              de sintomatología externa (bolsas en los ojos,
                              muñecas, tobillos, inflamación...)
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className='grid--2col'>
                    <div className='field'>
                      <label htmlFor='nutrHorarcom'>
                        ¿Cómo son los horarios de las distintas comidas del día?
                      </label>
                      <div className='control'>
                        <div className='select'>
                          <select
                            className='select'
                            id='nutrHorarcom'
                            name='nutrHorarcom'
                            readOnly
                            value={nutrHorarcom}
                          >
                            <option disabled value='default'>
                              -- Selecciona una opción --
                            </option>
                            <option value='muy-adec'>Muy adecuados</option>
                            <option value='bast-adec'>
                              Bastante adecuados
                            </option>
                            <option value='med-adec'>
                              Medianamente adecuados
                            </option>
                            <option value='poc-adec'>Poco adecuados</option>
                            <option value='in-adec'>Inadecuados</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className='grid--2col'>
                    <div className='field'>
                      <label htmlFor='nutrEvaldesay'>
                        Evaluación - Desayuno
                      </label>
                      <div className='control'>
                        <div className='select'>
                          <select
                            className='select'
                            id='nutrEvaldesay'
                            name='nutrEvaldesay'
                            readOnly
                            value={nutrEvaldesay}
                          >
                            <option disabled value='default'>
                              -- Selecciona una opción --
                            </option>
                            <option value='1-punt'>No realiza la comida</option>
                            <option value='2-punt'>
                              Ingiere alguna ración, pero en cantidad
                              insuficiente
                            </option>
                            <option value='3-punt'>
                              Ingiere raciones en cantidades adecuadas
                            </option>
                            <option value='4-punt'>
                              Ingiere raciones en exceso
                            </option>
                            <option value='5-punt'>
                              No sabe, no se acuerda
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className='field'>
                      <label htmlFor='nutrEvalman'>
                        Evaluación - Media mañana
                      </label>
                      <div className='control'>
                        <div className='select'>
                          <select
                            className='select'
                            id='nutrEvalman'
                            name='nutrEvalman'
                            readOnly
                            value={nutrEvalman}
                          >
                            <option disabled value='default'>
                              -- Selecciona una opción --
                            </option>
                            <option value='1-punt'>No realiza la comida</option>
                            <option value='2-punt'>
                              Ingiere alguna ración, pero en cantidad
                              insuficiente
                            </option>
                            <option value='3-punt'>
                              Ingiere raciones en cantidades adecuadas
                            </option>
                            <option value='4-punt'>
                              Ingiere raciones en exceso
                            </option>
                            <option value='5-punt'>
                              No sabe, no se acuerda
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className='field'>
                      <label htmlFor='nutrEvalcomid'>Evaluación - Comida</label>
                      <div className='control'>
                        <div className='select'>
                          <select
                            className='select'
                            id='nutrEvalcomid'
                            name='nutrEvalcomid'
                            readOnly
                            value={nutrEvalcomid}
                          >
                            <option disabled value='default'>
                              -- Selecciona una opción --
                            </option>
                            <option value='1-punt'>No realiza la comida</option>
                            <option value='2-punt'>
                              Ingiere alguna ración, pero en cantidad
                              insuficiente
                            </option>
                            <option value='3-punt'>
                              Ingiere raciones en cantidades adecuadas
                            </option>
                            <option value='4-punt'>
                              Ingiere raciones en exceso
                            </option>
                            <option value='5-punt'>
                              No sabe, no se acuerda
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className='field'>
                      <label htmlFor='nutrEvalmeri'>
                        Evaluación - Merienda
                      </label>
                      <div className='control'>
                        <div className='select'>
                          <select
                            className='select'
                            id='nutrEvalmeri'
                            name='nutrEvalmeri'
                            readOnly
                            value={nutrEvalmeri}
                          >
                            <option disabled value='default'>
                              -- Selecciona una opción --
                            </option>
                            <option value='1-punt'>No realiza la comida</option>
                            <option value='2-punt'>
                              Ingiere alguna ración, pero en cantidad
                              insuficiente
                            </option>
                            <option value='3-punt'>
                              Ingiere raciones en cantidades adecuadas
                            </option>
                            <option value='4-punt'>
                              Ingiere raciones en exceso
                            </option>
                            <option value='5-punt'>
                              No sabe, no se acuerda
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className='field'>
                      <label htmlFor='nutrEvalcena'>Evaluación - Cena</label>
                      <div className='control'>
                        <div className='select'>
                          <select
                            className='select'
                            id='nutrEvalcena'
                            name='nutrEvalcena'
                            readOnly
                            value={nutrEvalcena}
                          >
                            <option disabled value='default'>
                              -- Selecciona una opción --
                            </option>
                            <option value='1-punt'>No realiza la comida</option>
                            <option value='2-punt'>
                              Ingiere alguna ración, pero en cantidad
                              insuficiente
                            </option>
                            <option value='3-punt'>
                              Ingiere raciones en cantidades adecuadas
                            </option>
                            <option value='4-punt'>
                              Ingiere raciones en exceso
                            </option>
                            <option value='5-punt'>
                              No sabe, no se acuerda
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className='field'>
                      <label htmlFor='nutrEvallact'>Evaluación - Lácteos</label>
                      <div className='control'>
                        <div className='select'>
                          <select
                            className='select'
                            id='nutrEvallact'
                            name='nutrEvallact'
                            readOnly
                            value={nutrEvallact}
                          >
                            <option disabled value='default'>
                              -- Selecciona una opción --
                            </option>
                            <option value='1-punt'>No realiza la comida</option>
                            <option value='2-punt'>
                              Ingiere alguna ración, pero en cantidad
                              insuficiente
                            </option>
                            <option value='3-punt'>
                              Ingiere raciones en cantidades adecuadas
                            </option>
                            <option value='4-punt'>
                              Ingiere raciones en exceso
                            </option>
                            <option value='5-punt'>
                              No sabe, no se acuerda
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className='field'>
                      <label htmlFor='nutrEvalverd'>
                        Evaluación - Verduras/Hortalizas
                      </label>
                      <div className='control'>
                        <div className='select'>
                          <select
                            className='select'
                            id='nutrEvalverd'
                            name='nutrEvalverd'
                            readOnly
                            value={nutrEvalverd}
                          >
                            <option disabled value='default'>
                              -- Selecciona una opción --
                            </option>
                            <option value='1-punt'>No realiza la comida</option>
                            <option value='2-punt'>
                              Ingiere alguna ración, pero en cantidad
                              insuficiente
                            </option>
                            <option value='3-punt'>
                              Ingiere raciones en cantidades adecuadas
                            </option>
                            <option value='4-punt'>
                              Ingiere raciones en exceso
                            </option>
                            <option value='5-punt'>
                              No sabe, no se acuerda
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className='field'>
                      <label htmlFor='nutrEvalfrit'>Evaluación - Fritos</label>
                      <div className='control'>
                        <div className='select'>
                          <select
                            className='select'
                            id='nutrEvalfrit'
                            name='nutrEvalfrit'
                            readOnly
                            value={nutrEvalfrit}
                          >
                            <option disabled value='default'>
                              -- Selecciona una opción --
                            </option>
                            <option value='1-punt'>No realiza la comida</option>
                            <option value='2-punt'>
                              Ingiere alguna ración, pero en cantidad
                              insuficiente
                            </option>
                            <option value='3-punt'>
                              Ingiere raciones en cantidades adecuadas
                            </option>
                            <option value='4-punt'>
                              Ingiere raciones en exceso
                            </option>
                            <option value='5-punt'>
                              No sabe, no se acuerda
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className='field'>
                      <label htmlFor='nutrEvalcarn'>Evaluación - Carne</label>
                      <div className='control'>
                        <div className='select'>
                          <select
                            className='select'
                            id='nutrEvalcarn'
                            name='nutrEvalcarn'
                            readOnly
                            value={nutrEvalcarn}
                          >
                            <option disabled value='default'>
                              -- Selecciona una opción --
                            </option>
                            <option value='1-punt'>No realiza la comida</option>
                            <option value='2-punt'>
                              Ingiere alguna ración, pero en cantidad
                              insuficiente
                            </option>
                            <option value='3-punt'>
                              Ingiere raciones en cantidades adecuadas
                            </option>
                            <option value='4-punt'>
                              Ingiere raciones en exceso
                            </option>
                            <option value='5-punt'>
                              No sabe, no se acuerda
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className='field'>
                      <label htmlFor='nutrEvalfrut'>Evaluación - Frutas</label>
                      <div className='control'>
                        <div className='select'>
                          <select
                            className='select'
                            id='nutrEvalfrut'
                            name='nutrEvalfrut'
                            readOnly
                            value={nutrEvalfrut}
                          >
                            <option disabled value='default'>
                              -- Selecciona una opción --
                            </option>
                            <option value='1-punt'>No realiza la comida</option>
                            <option value='2-punt'>
                              Ingiere alguna ración, pero en cantidad
                              insuficiente
                            </option>
                            <option value='3-punt'>
                              Ingiere raciones en cantidades adecuadas
                            </option>
                            <option value='4-punt'>
                              Ingiere raciones en exceso
                            </option>
                            <option value='5-punt'>
                              No sabe, no se acuerda
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className='field'>
                      <label htmlFor='nutrEvalsals'>Evaluación - Salsas</label>
                      <div className='control'>
                        <div className='select'>
                          <select
                            className='select'
                            id='nutrEvalsals'
                            name='nutrEvalsals'
                            readOnly
                            value={nutrEvalsals}
                          >
                            <option disabled value='default'>
                              -- Selecciona una opción --
                            </option>
                            <option value='1-punt'>No realiza la comida</option>
                            <option value='2-punt'>
                              Ingiere alguna ración, pero en cantidad
                              insuficiente
                            </option>
                            <option value='3-punt'>
                              Ingiere raciones en cantidades adecuadas
                            </option>
                            <option value='4-punt'>
                              Ingiere raciones en exceso
                            </option>
                            <option value='5-punt'>
                              No sabe, no se acuerda
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className='field'>
                      <label htmlFor='nutrEvalpesc'>
                        Evaluación - Pescados
                      </label>
                      <div className='control'>
                        <div className='select'>
                          <select
                            className='select'
                            id='nutrEvalpesc'
                            name='nutrEvalpesc'
                            readOnly
                            value={nutrEvalpesc}
                          >
                            <option disabled value='default'>
                              -- Selecciona una opción --
                            </option>
                            <option value='1-punt'>No realiza la comida</option>
                            <option value='2-punt'>
                              Ingiere alguna ración, pero en cantidad
                              insuficiente
                            </option>
                            <option value='3-punt'>
                              Ingiere raciones en cantidades adecuadas
                            </option>
                            <option value='4-punt'>
                              Ingiere raciones en exceso
                            </option>
                            <option value='5-punt'>
                              No sabe, no se acuerda
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className='field'>
                      <label htmlFor='nutrEvallegu'>
                        Evaluación - Legumbres
                      </label>
                      <div className='control'>
                        <div className='select'>
                          <select
                            className='select'
                            id='nutrEvallegu'
                            name='nutrEvallegu'
                            readOnly
                            value={nutrEvallegu}
                          >
                            <option disabled value='default'>
                              -- Selecciona una opción --
                            </option>
                            <option value='1-punt'>No realiza la comida</option>
                            <option value='2-punt'>
                              Ingiere alguna ración, pero en cantidad
                              insuficiente
                            </option>
                            <option value='3-punt'>
                              Ingiere raciones en cantidades adecuadas
                            </option>
                            <option value='4-punt'>
                              Ingiere raciones en exceso
                            </option>
                            <option value='5-punt'>
                              No sabe, no se acuerda
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className='field'>
                      <label htmlFor='nutrEvalcafte'>
                        Evaluación - Café/Té
                      </label>
                      <div className='control'>
                        <div className='select'>
                          <select
                            className='select'
                            id='nutrEvalcafte'
                            name='nutrEvalcafte'
                            readOnly
                            value={nutrEvalcafte}
                          >
                            <option disabled value='default'>
                              -- Selecciona una opción --
                            </option>
                            <option value='1-punt'>No realiza la comida</option>
                            <option value='2-punt'>
                              Ingiere alguna ración, pero en cantidad
                              insuficiente
                            </option>
                            <option value='3-punt'>
                              Ingiere raciones en cantidades adecuadas
                            </option>
                            <option value='4-punt'>
                              Ingiere raciones en exceso
                            </option>
                            <option value='5-punt'>
                              No sabe, no se acuerda
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className='field'>
                      <label htmlFor='nutrEvalhuev'>Evaluación - Huevos</label>
                      <div className='control'>
                        <div className='select'>
                          <select
                            className='select'
                            id='nutrEvalhuev'
                            name='nutrEvalhuev'
                            readOnly
                            value={nutrEvalhuev}
                          >
                            <option disabled value='default'>
                              -- Selecciona una opción --
                            </option>
                            <option value='1-punt'>No realiza la comida</option>
                            <option value='2-punt'>
                              Ingiere alguna ración, pero en cantidad
                              insuficiente
                            </option>
                            <option value='3-punt'>
                              Ingiere raciones en cantidades adecuadas
                            </option>
                            <option value='4-punt'>
                              Ingiere raciones en exceso
                            </option>
                            <option value='5-punt'>
                              No sabe, no se acuerda
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className='field'>
                      <label htmlFor='nutrEvalcere'>
                        Evaluación - Cereales
                      </label>
                      <div className='control'>
                        <div className='select'>
                          <select
                            className='select'
                            id='nutrEvalcere'
                            name='nutrEvalcere'
                            readOnly
                            value={nutrEvalcere}
                          >
                            <option disabled value='default'>
                              -- Selecciona una opción --
                            </option>
                            <option value='1-punt'>No realiza la comida</option>
                            <option value='2-punt'>
                              Ingiere alguna ración, pero en cantidad
                              insuficiente
                            </option>
                            <option value='3-punt'>
                              Ingiere raciones en cantidades adecuadas
                            </option>
                            <option value='4-punt'>
                              Ingiere raciones en exceso
                            </option>
                            <option value='5-punt'>
                              No sabe, no se acuerda
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className='field'>
                      <label htmlFor='nutrEvaldulc'>Evaluación - Dulces</label>
                      <div className='control'>
                        <div className='select'>
                          <select
                            className='select'
                            id='nutrEvaldulc'
                            name='nutrEvaldulc'
                            readOnly
                            value={nutrEvaldulc}
                          >
                            <option disabled value='default'>
                              -- Selecciona una opción --
                            </option>
                            <option value='1-punt'>No realiza la comida</option>
                            <option value='2-punt'>
                              Ingiere alguna ración, pero en cantidad
                              insuficiente
                            </option>
                            <option value='3-punt'>
                              Ingiere raciones en cantidades adecuadas
                            </option>
                            <option value='4-punt'>
                              Ingiere raciones en exceso
                            </option>
                            <option value='5-punt'>
                              No sabe, no se acuerda
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className='field'>
                      <label htmlFor='nutrEvalemb'>
                        Evaluación - Embutidos
                      </label>
                      <div className='control'>
                        <div className='select'>
                          <select
                            className='select'
                            id='nutrEvalemb'
                            name='nutrEvalemb'
                            readOnly
                            value={nutrEvalemb}
                          >
                            <option disabled value='default'>
                              -- Selecciona una opción --
                            </option>
                            <option value='1-punt'>No realiza la comida</option>
                            <option value='2-punt'>
                              Ingiere alguna ración, pero en cantidad
                              insuficiente
                            </option>
                            <option value='3-punt'>
                              Ingiere raciones en cantidades adecuadas
                            </option>
                            <option value='4-punt'>
                              Ingiere raciones en exceso
                            </option>
                            <option value='5-punt'>
                              No sabe, no se acuerda
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className='field'>
                      <label htmlFor='nutrEvalagua'>Evaluación - Agua</label>
                      <div className='control'>
                        <div className='select'>
                          <select
                            className='select'
                            id='nutrEvalagua'
                            name='nutrEvalagua'
                            readOnly
                            value={nutrEvalagua}
                          >
                            <option disabled value='default'>
                              -- Selecciona una opción --
                            </option>
                            <option value='1-punt'>No realiza la comida</option>
                            <option value='2-punt'>
                              Ingiere alguna ración, pero en cantidad
                              insuficiente
                            </option>
                            <option value='3-punt'>
                              Ingiere raciones en cantidades adecuadas
                            </option>
                            <option value='4-punt'>
                              Ingiere raciones en exceso
                            </option>
                            <option value='5-punt'>
                              No sabe, no se acuerda
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className='field'>
                      <label htmlFor='nutrEvalfsec'>
                        Evaluación - Frutos secos
                      </label>
                      <div className='control'>
                        <div className='select'>
                          <select
                            className='select'
                            id='nutrEvalfsec'
                            name='nutrEvalfsec'
                            readOnly
                            value={nutrEvalfsec}
                          >
                            <option disabled value='default'>
                              -- Selecciona una opción --
                            </option>
                            <option value='1-punt'>No realiza la comida</option>
                            <option value='2-punt'>
                              Ingiere alguna ración, pero en cantidad
                              insuficiente
                            </option>
                            <option value='3-punt'>
                              Ingiere raciones en cantidades adecuadas
                            </option>
                            <option value='4-punt'>
                              Ingiere raciones en exceso
                            </option>
                            <option value='5-punt'>
                              No sabe, no se acuerda
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className='field'>
                      <label htmlFor='nutrEvalrefr'>
                        Evaluación - Refrescos
                      </label>
                      <div className='control'>
                        <div className='select'>
                          <select
                            className='select'
                            id='nutrEvalrefr'
                            required
                            name='nutrEvalrefr'
                            readOnly
                            value={nutrEvalrefr}
                          >
                            <option disabled value='default'>
                              -- Selecciona una opción --
                            </option>
                            <option value='1-punt'>No realiza la comida</option>
                            <option value='2-punt'>
                              Ingiere alguna ración, pero en cantidad
                              insuficiente
                            </option>
                            <option value='3-punt'>
                              Ingiere raciones en cantidades adecuadas
                            </option>
                            <option value='4-punt'>
                              Ingiere raciones en exceso
                            </option>
                            <option value='5-punt'>
                              No sabe, no se acuerda
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <></>
              )}

              <div className='field'>
                <label className='' htmlFor='nutrObs'>
                  Observaciones
                </label>
                <div className='control'>
                  <textarea
                    className='textarea'
                    name='nutrObs'
                    id='nutrObs'
                    readOnly
                    value={nutrObs}
                  ></textarea>
                </div>
              </div>
            </fieldset>
          </form>
        )}
      </div>
      {!errorMessage && (
        <div id='actions'>
          {((diffDate <= 72 && props.userRole.includes('nutricion')) || props.userRole.includes('administrador')) && (
            <Link className='button is-link' to={`edit`}>
              Editar
            </Link>
          )}
          {(props.userRole.includes('administrador') || props.userRole.includes('nutricion')) && (
            <Link
              className='button is-link'
              to={`../${tratamientoId}/seguimiento/nutricion/new`}
            >
              Nuevo
            </Link>
          )}
        </div>
      )}
    </>
  );
}
